import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgramArchived/OutletTypeApi";
import store from "../../../../Frontends/Common/store";

export class OutletTypeService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editOutletType", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editOutletType");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getOutletTypes", args);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getOutletType", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createOutletType", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteOutletType", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editOutletType", model);
  }
  async import(gfid) {
    const res = this.Api.import(gfid);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async getImportScaffold() {
    return await this.Api.getImportScaffold();
  }
  async export(filter, format) {
    const res = this.Api.export(filter, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
}
